import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IGroup } from '../../groups/IGroups';
import { flatDeep } from '../../shared';
import { SelectItem } from '../../shared/efaact-primeng.module';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Reminder } from '../store';

@Component({
    selector: 'ef-reminder-add',
    templateUrl: './reminder-add.component.html',
    styleUrls: ['./reminder-add.component.scss'],
    standalone: false
})
export class ReminderAddComponent implements OnInit {
    addReminderForm: UntypedFormGroup;
    @Input() reminderTypes: SelectItem[];
    @Input() reminderScheduleTypes: SelectItem[];
    @Input() recipients: IGroup[];
    @Input() reminderGroups: Array<{ id: number; groups: number[] }>;
    @Input() reminderReviewPeriods: SelectItem[];
    @Input() show = false;
    @Output() Save = new EventEmitter<Reminder>();
    @Output() Cancel = new EventEmitter();
    reminder: Reminder = {} as Reminder;
    constructor(
        private log: LoggingService,
        private confirmservice: UnsavedChangesService
    ) {
        this.addReminderForm = new UntypedFormGroup({
            Reminderinstanceid: new UntypedFormControl(-1),
            Reminderinstancename: new UntypedFormControl(
                this.reminder.Reminderinstancename,
                Validators.required
            ),
            Remindertypeid: new UntypedFormControl(
                this.reminder.Remindertypeid,
                Validators.required
            ),
            Reminderreviewperiod: new UntypedFormControl(
                this.reminder.Reminderreviewperiod,
                Validators.required
            ),
            Groupid: new UntypedFormControl(
                this.reminder.Groupid,
                Validators.required
            ),
            Notifysupervisor: new UntypedFormControl(
                this.reminder.Notifysupervisor || false
            ),
            ReminderScheduleID: new UntypedFormControl(
                this.reminder.ReminderScheduleID,
                Validators.required
            ),
            Scheduletime: new UntypedFormControl(
                this.reminder.Scheduletime,
                Validators.required
            ),
            Subject: new UntypedFormControl(
                this.reminder.Subject,
                Validators.required
            ),
            Comment: new UntypedFormControl(this.reminder.Comment, Validators.required)
        });
    }
    ngOnInit() {}
    onSave() {
        const form = this.addReminderForm;
        this.log.verbose({
            type: 'ReminderAddComponent:SaveNewReminder',
            value: form.value
        });
        form.markAsTouched();
        Object.keys(form.controls).forEach(key => {
            form.controls[key].markAsTouched();
            form.controls[key].markAsDirty();
        });
        form.updateValueAndValidity();
        if (form.valid) {
            this.Save.next(this.addReminderForm.value);
            this.addReminderForm.reset({ Reminderinstanceid: -1 });
        }
    }
    onCancel() {
        this.Cancel.emit();
    }

    groupsForReminderType(typeId: number) {
        const groups = flatDeep<number>(
            this.reminderGroups.filter(y => y.id === typeId).map(x => x.groups)
        ) as number[];
        const results = this.recipients
            .filter(x => groups.includes(x.GroupID) || x.IsRole === false)
            .map(x => ({ label: x.GroupName, value: x.GroupID } as SelectItem));
        this.log.verbose({
            type: 'ReminderAddComponent:groupsForReminderType',
            typeId,
            groups,
            results
        });
        return results;
    }
}
